class EditorialHero extends HTMLElement {
  constructor() {
    super();

    this.heading = this.querySelector('.editorial-hero__heading > span');

    this.setup();
    this.handleJobVacancySection();
  }

  setup() {
    this.setSize();
  }

  setSize() {
    const width = window.innerWidth;
    const headingWidth = this.heading.offsetWidth;
    const fontSize = parseInt(window.getComputedStyle(this.heading).fontSize);
    const vw = (((width / headingWidth) * fontSize) / width) * 100 + 1;

    this.heading.style.fontSize = `${vw}vw`;
  }

  handleJobVacancySection() {
    const vacancies = document.querySelector('job-vacancies');

    if (!vacancies) return;

    const buttonWrap = this.querySelector('.editorial-hero__text > div:last-child');

    const newLink = document.createElement('a');

    newLink.href = '#job-vacancies';
    newLink.innerHTML = '<span><span><span>Jump To Vacancies</span><span>Jump To Vacancies</span></span></span>';
    newLink.classList = 'button button--tertiary scroll-trigger';
    newLink.setAttribute('aria-label', 'Jump to vacancies');

    if (buttonWrap) {
      newLink.style.setProperty('--animation-delay', `2.08`);
      buttonWrap.appendChild(newLink);
    } else {
      newLink.style.setProperty('--animation-delay', `2`);

      const newDiv = document.createElement('div');
      newDiv.style.display = 'flex';
      newDiv.style.justifyContent = 'center';
      newDiv.style.gap = '16px';

      const buttonWrapParent = this.querySelector('.editorial-hero__text');

      newDiv.appendChild(newLink);
      buttonWrapParent.appendChild(newDiv);
    }

    newLink.addEventListener('click', (e) => {
      e.preventDefault();

      if (vacancies) {
        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: vacancies,
            offsetY: 150,
          },
          ease: 'power3.inOut',
        });
      }
    });
  }
}

customElements.define('editorial-hero', EditorialHero);
